import Api from "../apiService";

class FleetVehicleInspectionsApi {
  forCompany(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/fleet/vehicle/inspections`,
      params,
      Api.authHeaders()
    );
  }

  index(companyId, vehicleId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, vehicleId, id) {
    return Api.getRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, vehicleId, data) {
    return Api.postRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, vehicleId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections/${id}`,
      data,
      Api.authHeaders()
    );
  }

  answer(companyId, vehicleId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections/${id}/answer`,
      data,
      Api.authHeaders()
    );
  }

  complete(companyId, vehicleId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections/${id}/complete`,
      data,
      Api.authHeaders()
    );
  }

  sign(companyId, vehicleId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections/${id}/sign`,
      data,
      Api.authHeaders()
    );
  }

  cancel(companyId, vehicleId, id) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections/${id}/cancel`,
      {},
      Api.authHeaders()
    );
  }

  destroy(companyId, vehicleId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/vehicles/${vehicleId}/inspections/${id}`,
      Api.authHeaders()
    );
  }
}

export default new FleetVehicleInspectionsApi();
